import BrokersApi from '../BrokersApi';
import * as types from './ActionTypes';
import IBrokerTreeNode from '../IBrokerTreeNode';
import IBrokerFirmGroup from '../firmGroup/IBrokerFirmGroup';

function newBrokerFirmGroupSuccess(result: any) {
    return { type: types.NEW_BROKER_FIRMGROUP_SUCCESS, result };
}

export function newBrokerFirmGroup(parentId: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.newBrokerFirmGroup(parentId).then((result: any) => {
            dispatch(newBrokerFirmGroupSuccess(result));
        });
}

function createBrokerFirmGroupSuccess(result: IBrokerFirmGroup) {
    return { type: types.CREATE_BROKER_FIRMGROUP_SUCCESS, result };
}

export function createBrokerFirmGroup(data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.createBrokerFirmGroup(data).then((result: IBrokerFirmGroup) => {
            dispatch(createBrokerFirmGroupSuccess(result));
        });
}

function editBrokerFirmGroupSuccess(result: any) {
    return { type: types.EDIT_BROKER_FIRMGROUP_SUCCESS, result };
}

export function editBrokerFirmGroup(id: number) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.editBrokerFirmGroup(id).then((result: any) => {
            dispatch(editBrokerFirmGroupSuccess(result));
        });
}

function updateBrokerFirmGroupSuccess(result: IBrokerFirmGroup) {
    return { type: types.UPDATE_BROKER_FIRMGROUP_SUCCESS, result };
}

export function updateBrokerFirmGroup(id: number, data: any) {
    return (dispatch: (result: any) => void) =>
        BrokersApi.updateBrokerFirmGroup(id, data).then((result: IBrokerFirmGroup) => {
            dispatch(updateBrokerFirmGroupSuccess(result));
        });
}
